export function ScorebookLoyalistIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="14" y="6" width="20" height="36" rx="2" />
      <line x1="14" y1="12" x2="34" y2="12" />
      <line x1="14" y1="36" x2="34" y2="36" />
      <path d="M22 20l2 2 4-4" />
      <path d="M22 28l2 2 4-4" />
    </svg>
  );
}
